module.exports = __webpack_public_path__ + "static/img/Image-3-11-24-at-11.31AM.e200f217.jpeg";